module.exports = __webpack_public_path__ + "static/media/banner-app-svg.6c1741bc.svg";